// extracted by mini-css-extract-plugin
module.exports = {"container":"OfflineOrderDetails_container__hEhLd","wrapper":"OfflineOrderDetails_wrapper__wJGQ3","buttons":"OfflineOrderDetails_buttons__1LZV4"};